module.exports = __webpack_public_path__ + "static/media/360-2-1.388af1e1.webp";